var map = {
	"./1.svg": "4327",
	"./11.svg": "5e5c",
	"./2.svg": "ea9c",
	"./22.svg": "b02b",
	"./3.svg": "922a",
	"./33.svg": "e202",
	"./4.svg": "1815",
	"./44.svg": "cdf6",
	"./5.svg": "935c",
	"./55.svg": "c042",
	"./6.svg": "e7ec",
	"./66.svg": "6ae7",
	"./7.svg": "feba",
	"./77.svg": "e48b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ee35";